if ( typeof scopePageStyles !== 'function' ) {

	const SCOPE_SELECTOR = '.main-page .rte';

	const prefixSelectorList = (selectorText) => {
		return selectorText.split(',').map((part) => {
			const selector = part.trim();
			if ( ! selector || selector.indexOf(SCOPE_SELECTOR) === 0 ) return selector;
			if ( /^(html|body|:root)\b/.test(selector) ) {
				return selector.replace(/^(html|body|:root)/, SCOPE_SELECTOR);
			}
			return `${SCOPE_SELECTOR} ${selector}`;
		}).join(', ');
	}

	const rewriteRules = (rules) => {
		let css = '';
		for ( const rule of rules ) {
			if ( rule.type === CSSRule.STYLE_RULE ) {
				css += `${prefixSelectorList(rule.selectorText)} { ${rule.style.cssText} }\n`;
			} else if ( rule.type === CSSRule.MEDIA_RULE ) {
				css += `@media ${rule.conditionText} {\n${rewriteRules(rule.cssRules)}}\n`;
			} else if ( rule.type === CSSRule.SUPPORTS_RULE ) {
				css += `@supports ${rule.conditionText} {\n${rewriteRules(rule.cssRules)}}\n`;
			} else {
				// keyframes, font-face, etc. don't carry selectors that can leak - keep as-is
				css += `${rule.cssText}\n`;
			}
		}
		return css;
	}

	scopePageStyles = () => {
		document.querySelectorAll(`${SCOPE_SELECTOR} style:not([data-scoped])`).forEach((style) => {
			if ( ! style.sheet ) return;

			let rewritten;
			try {
				rewritten = rewriteRules(style.sheet.cssRules);
			} catch (e) {
				return;
			}

			const scoped = document.createElement('style');
			scoped.dataset.scoped = 'true';
			scoped.textContent = rewritten;
			style.replaceWith(scoped);
		});
	}

	scopePageStyles();

}
